export default __webpack_public_path__ + "assets/images/671d04c2f3a69d4bba64129e171f8c13.svg";